// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-card .am-card .am-card-body::after {\n  content: '';\n  position: absolute;\n  background-color: #F4F4F4;\n  display: block;\n  z-index: 1;\n  bottom: 0;\n  margin-left: 0.24rem;\n  width: calc(100% - 0.48rem);\n  height: 0.02rem;\n}\n", ""]);
// Exports
module.exports = exports;
